export default "__VITE_ASSET__057b2914__"